import { pxToRem } from './px-to-rem';

export const breakpointsPx = [760, 1100, 1400, 1600];

export const breakpoints = breakpointsPx.map(pxToRem);
